<template>
<pop-up-layout 
  :title="$t('promociones.plantillaTitulo')"
  :description="$t('promociones.textoPlantilla', {promo: promocion.descripcion})"
  :loading="loading"
  :saving="waitingForLoad"
  :loadingText="$t('general.misc.cargando')"
  @volver="$parent.hide()"
  @aceptar="guardar()"
>
  <o-description-title v-if="plantillas.length < 1">
    {{$t('promociones.textoPlantillaPromo')}}
  </o-description-title>
  <v-data-table
    :headers="headers"
    :items="plantillas"
    hide-actions
    class="mb-2"
  >
    <template #items="props">
      <tr :class="{pointer: $vuetify.breakpoint.smAndDown}">
        <td>
            {{ props.item.nombre }}
        </td>
        <td>
            {{ $t('general.idiomas.' + props.item.idioma) }}
        </td>
        <td>
            {{ props.item.ambito }}
        </td>
        <td>
          <v-layout justify-center align-center>
            <v-checkbox
              :ripple="false"
              readonly
              color="primary"
              class="grey--text pl-2"
              v-model="props.item.esPorDefecto" 
              style="pointer-events:none;flex-grow:0;"
              hide-details
            />
          </v-layout>
        </td>
        <td class="text-xs-right pr-0">
          <v-btn
            @click.stop
            :href="$plantillaDocumento(props.item.plantillaId)" target="_blank"
            color="primary"
          >
            {{$t('promociones.verDoc')}}
          </v-btn>
        </td>
      </tr>
    </template>
  </v-data-table>
</pop-up-layout>
</template>


<script>
import { mapGetters, mapActions } from 'vuex'
import rules from '@/mixins/rules'

export default {
  mixins: [rules],
  props: {
    codigoPromocion: {
      type: String,
      required: true
    }
  },
  data () {
    return {
      waitingForLoad: false,
      loading: true,
      documentos: [],
      esPorDefecto: false
    }
  },
  async created () {
    try {
      this.loading = true
      await this.loadPromocion(this.codigoPromocion)
      await this.loadPromocionPlantillas(this.codigoPromocion)
      this.loading = false
    } catch (error) {
      this.waitingForLoad = false
      if (!error.code || error.code !== 1) {
        this.addAlert({texto: error.message, color: 'error'})
      }
    }
  },
  computed: {
    ...mapGetters({
      getPromocion: 'promociones/getActual',
      getPromocionPlantillas: 'promocionesPlantillas/getAll'
    }),
    headers () {
      return [
        {
          text: this.$t('pages.incrustado.documento'),
          value: 'nombre',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('general.misc.idioma'),
          value: 'idioma',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('promociones.ambito'),
          value: 'ambito',
          align: 'left',
          sortable: true
        },
        {
          text: this.$t('promociones.plantillaDefecto'),
          value: 'esPorDefecto',
          align: 'center',
          sortable: true
        },
        {
          text: this.$t('general.misc.acciones'),
          value: '',
          align: 'right',
          sortable: false
        }

      ]
    },
    promocion () {
      return this.getPromocion
    },
    plantillas () {
      return this.getPromocionPlantillas.map(x => {
        return {
          ambito: x.ambito ? (x.ambito === 'VTA' ? this.$t('general.misc.venta') : this.$t('general.misc.alquiler')) : null,
          esPorDefecto: x.esPorDefecto,
          nombre: x.plantilla.nombre,
          descripcion: x.plantilla.descripcion,
          idioma: x.plantilla.idioma.toLowerCase(),
          id: x.id,
          plantillaId: x.plantilla.id
        }
      }).sort((x, y) => x.nombre.localeCompare(y.nombre))
    }
  },
  methods: {
    ...mapActions({
      addAlert: 'alerts/add',
      loadPromocion: 'promociones/loadPromocion',
      loadPromocionPlantillas: 'promocionesPlantillas/loadAll'
    })
  }
}
</script>


// WEBPACK FOOTER //
// src/components/promociones/PopUpPromocionesPlantillas.vue